import { connect } from 'react-redux'
import find from 'lodash/find'

import FooterLayoutOne from 'components/hub-page/views/sections/footer/layouts/one'
import fontFamilies from 'configs/font-families'

const mapStateToProps = (state, ownProps) => {
  const fetchedContentFont = find(fontFamilies, (f) => f.key === state.theme.theme.contentFont)
  const footerSectionIndex = state.homePageRevision &&
    state.homePageRevision.revision.sections &&
    state.homePageRevision.revision.sections.length - 1

  const fetchedProps = {
    meta: (footerSectionIndex && state.homePageRevision.revision.sections[footerSectionIndex].meta) ||
      state.hubPageRevision.revision.sections[ownProps.sectionId].meta,
    data: (footerSectionIndex && state.homePageRevision.revision.sections[footerSectionIndex].data[0]) ||
      state.hubPageRevision.revision.sections[ownProps.sectionId].data[0],
    backgroundColor: (footerSectionIndex && state.homePageRevision.revision.sections[footerSectionIndex].theme.backgroundColor) ||
      state.hubPageRevision.revision.sections[ownProps.sectionId].theme.backgroundColor,
    textColor: (footerSectionIndex && state.homePageRevision.revision.sections[footerSectionIndex].theme.textColor) ||
      state.hubPageRevision.revision.sections[ownProps.sectionId].theme.textColor,
    fontFamily: (fetchedContentFont && fetchedContentFont.name) || fontFamilies[0].name,
    links: state.adminFooterLinks.footerLinks,
    dataTestId: 'participant-hubs-views-footer-section-layout-one'
  }

  return fetchedProps
}

export default connect(mapStateToProps)(FooterLayoutOne)
